'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouter = require('react-router');

var _ = require('./..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tooltip = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Tooltip, _React$Component);

  function Tooltip() {
    (0, _classCallCheck3.default)(this, Tooltip);
    return (0, _possibleConstructorReturn3.default)(this, (Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call(this));
  }

  (0, _createClass3.default)(Tooltip, [{
    key: 'render',
    value: function render() {
      var styles = require('./Tooltip.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.Tooltip },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('span', { className: styles['Tooltip__mini-profile-angle'] }),
          _react2.default.createElement(
            'div',
            { className: styles.Tooltip__inner },
            _react2.default.createElement(
              'span',
              null,
              'Buying a Megascans Pack does not affect your subscription points/quota.'
            )
          )
        )
      );
    }
  }]);
  return Tooltip;
}(_react2.default.Component), _class.contextTypes = {}, _temp);
exports.default = Tooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Tooltip/Tooltip.jsx
// module id = 2708
// module chunks = 0